import React from 'react';
import { IDateCell } from './interfaces';
import { ValueCell } from '../ValueCell';
import { formatLocaleDate } from '../../../helpers/dateHelpers';

export const DateCell: React.FC<IDateCell> = ({
  date,
  withTime = true,
  ...props
}): JSX.Element => {
  return (
    <ValueCell
      value={date ? formatLocaleDate(date, withTime) : undefined}
      {...props}
    />
  );
};
